import {Component, OnInit} from '@angular/core';
import {AuthService} from "../../../services/auth.service";

@Component({
    selector: 'app-inventory',
    templateUrl: './inventory.component.html',
    styleUrls: ['./inventory.component.scss'],
    providers: []
})
export class InventoryComponent implements OnInit {

    constructor(public authService: AuthService) {
    }

    ngOnInit(): void {

        //

    }
}
